/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { IDefinition } from '../../../models/common/IDefinition';
import { Parameter } from '../../../models/common/Parameter';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasMissingParameterLocationRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        if(this.hasValue(node.$ref)) {
            return;
        }
        this.requireProperty(node, Constants.PROP_IN, this.map.apply(this, ));
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.visitParameter(<Parameter><any>node);
    }
}
OasMissingParameterLocationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.OasMissingParameterLocationRule";
OasMissingParameterLocationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




